export default function TopBar() {
  return (
    <div className="bg-gray-100 text-sm py-2 px-10 flex justify-between">
      <div className="flex gap-6 text-gray-600">
        <span>White Label</span>
        <span>Affiliate</span>
        <span>Blog</span>
        <span>WordPress</span>
        <span>YouTube</span>
      </div>
      <div className="text-gray-600">English</div>
    </div>
  );
}
